import { ReportTypes } from '@mode/shared/contract-common';
import { TrackClickData } from '@mode/shared/util-segment';
import { DateTime } from '@mode-switch/express';
import { MetaTags, MetaTagsService, LocalStorageService } from '@mode/shared/util-js';
import { AnalyticsEvent } from '@mode/shared/util-segment';

export function existingDataOption(trackClickData: TrackClickData): ReportTypes.ReportCreationMenuItem {
  return {
    href: '/editor/reports/new',
    title: 'Use a Dataset',
    subtitle: 'Browse & chart off existing Datasets',
    icon: 'illo-use-data',
    class: 'new-report',
    testAttribute: 'create-new-report-with-existing-data',
    trackClickData,
  };
}

export function writeSqlOption(org: string, trackClickData: TrackClickData): ReportTypes.ReportCreationMenuItem {
  return {
    href: `/editor/${org}/reports/new`,
    title: 'Write SQL',
    subtitle: 'Query data for ad-hoc Reports',
    icon: 'illo-write-sql',
    class: 'new-report',
    testAttribute: 'create-new-report-with-sql',
    trackClickData,
  };
}

export function reusableDatasetOption(org: string, trackClickData: TrackClickData): ReportTypes.ReportCreationMenuItem {
  return {
    href: `/editor/${org}/datasets/new`,
    title: 'Make a new Dataset',
    subtitle: 'Query to create & share data tables',
    icon: 'illo-dataset-sql',
    class: 'new-dataset',
    testAttribute: 'create-new-dataset',
    trackClickData,
  };
}

export function uploadSheetOption(
  subtitle: string,
  location: AnalyticsEvent.SubContext.GoogleSheetUploadPlusMenu | AnalyticsEvent.SubContext.GoogleSheetUploadTile,
  localStorageService: LocalStorageService,
  metaTagService: MetaTagsService
): ReportTypes.ReportCreationMenuItem {
  return {
    href: '#',
    title: 'Upload a Google Sheet',
    subtitle,
    icon: 'illo-gsheets-feature',
    class: 'new-sheet',
    testAttribute: 'upload-new-sheet',
    trackClickData: {
      location,
      action: AnalyticsEvent.Name.GoogleSheetUploadLaunched,
      session_ID: localStorageService.getItem('LAST_ACTIVE_TAB_ID'),
      user_ID: metaTagService.getTag(MetaTags.CurrentUsername),
      timestamp: DateTime,
    },
  };
}
